import React from "react";

import { Row, Col } from "react-bootstrap";
import FASTable from "../../../../../components/Tables/FASTable";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import { RecAgingDtl } from "../../../../../Redux/Slice/Fas/ReceivablePayble/ReceivablePaybleSlice";
import { format } from "date-fns";
import { Loader } from "../../../../../components/Loader/Loader";
import { useTheme } from "../../../../../Themecontext/Themecontext";

export default function AgeingDetail() {
  const { Colourdata } = useSelector((state) => state.ClientLogin);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  const { RecAgingDtldata } = useSelector(
    (state) => state.ReceivablePaybleSlice,
  );

  function formatDateToDDMMYYYY(isoString) {
    if (!isoString) return "";

    const dateObj = new Date(isoString);
    if (isNaN(dateObj)) return ""; // Invalid date guard

    const day = String(dateObj.getDate()).padStart(2, "0");
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const year = dateObj.getFullYear();

    return `${day}/${month}/${year}`;
  }

  const getRows = RecAgingDtldata?.Detail?.map((label, index) => ({
    // srNumber: index + 1,
    AcName: label.AcName,
    VouDate: formatDateToDDMMYYYY(label.VouDate),
    AgingDays: label.AgingDays,
    DaysAfterReceipt: label.DaysAfterReceipt,
    DueDays: label.DueDays,
    InvoiceNum: label.InvoiceNum,
    OustandingAmount: label.OustandingAmount,
    Status: label.Status,
  }));

  const getColumns = [
    // { Header: "Chart", accessor: "chartButton", width: 60 },
    { label: "Sr. No.", key: "srNumber", align: "center" },
    {
      label: "Party Name",
      key: "AcName",
      align: "left",
      colors: isdark === "light" ? "#000" : "#fff",
    },
    { label: "Invoice Number", key: "InvoiceNum", align: "center" },
    { label: "Vou Date", key: "VouDate", align: "center" },
    { label: "Due Days", key: "DueDays", align: "right" },
    {
      label: "Oustanding Amount",
      key: "OustandingAmount",
      format: true,
      align: "right",
    },
    { label: "Ageing Days", key: "AgingDays", align: "right" },
    { label: "Days After Receipt", key: "DaysAfterReceipt", align: "right" },
    { label: "Status", key: "Status", align: "right" },
  ];
  const cardStyle = {
    background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour2,
    border: `1px solid ${isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour10
      }`,
    borderLeft: `6px solid ${isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10
      }`,
    borderRadius: "12px",
    padding: "10px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    height: "100%",
  };

  const titleStyle = {
    color: isdark === "light" ? iscolour?.Colour12 : iscolourDark?.Colour12,
    fontWeight: "600",
  };

  const subtitleStyle = {
    marginTop: "10px",
    fontWeight: "500",
    color: isdark === "light" ? iscolour?.Colour6 : iscolourDark?.Colour10,
  };

  const formatAmount = (amount) => {
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(amount || 0));
  };

  const ageingData = Object.entries(
    RecAgingDtldata?.AgingBuckets?.[0] || {}
  )
    .filter(([key]) => key.includes("Days") || key.includes("Above"))
    .map(([title, value]) => ({
      title,
      value,
    }));

  if (RecAgingDtldata === "no" || RecAgingDtldata === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-[#502000]">
        <Loader />
      </div>
    );
  }
  
  return (
    <div>
      <Row className="g-3">
        {ageingData.map((item, index) => (
          <Col
            key={index}
            xl={2}
            lg={4}
            md={4}
            sm={6}
            xs={12}
            className="quarter-box"
          >
            <div style={cardStyle}>
              <h6 style={subtitleStyle}>
                {formatAmount(item.value)}
              </h6>

              <p style={titleStyle}>
                {item.title}
              </p>
            </div>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: "20px" }}>
        <div
          style={{
            borderRadius: "12px",
            overflow: "hidden",
            boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
          }}
        >
          <div
            style={{
              backgroundColor:
                isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour4,
              color:
                isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour11,
              padding: "14px",
              margin: 0,
            }}
          >
            <h2
              style={{
                fontSize: "18px",
                margin: 0,
                letterSpacing: "1px",
                fontWeight: "600",
              }}
            >
              AGEING DETAIL
            </h2>
          </div>
          <FASTable data={getRows} columns={getColumns} externalTotals={RecAgingDtldata?.Status[0]} />



        </div>
      </div>
    </div>
  );
}
